import React from 'react';
import PropTypes from 'prop-types';

import {withWidgetContext} from '../widgetComponent/widgetContextProvider';

import VIDABOO_CONSTANTS from '../../config/consts';
import {
  ListeningRoomService,
  ShoutingRoomService,
} from '../../services/websocketService';
import PostMessageService from '../../services/postMessageService';
import UtilsService from '../../services/utilsService';
import VisibilityHandlerService from '../../services/visibilityHandlerService';

const propTypes = {
  peerUserId: PropTypes.string,
  currentUser: PropTypes.object,
  mentor: PropTypes.object,
  // funcs
  getPageLocation: PropTypes.func,
};
class DagComponent extends React.Component {
  state = {};
  componentDidMount = () => {
    this.peerUserId = this.props.peerUserId;
    this.currentUser = this.props.currentUser;
    this.myUserId = this.props.currentUser.userId;
    this.pageViewStartTime = new Date().getTime();
    this.isMobileDevice = UtilsService.isMobileDevice(); //todomcss : ok
    this.registerTrippleClickAction();
    window.addEventListener('click', this.handleClickEvent);
    this.registerListeners();
    this.waitForMeAvailablePromise();
    // });
    // authentication service automatically publishes "available" in own shouting room
  };
  componentWillUnmount = () => {
    this.deleteDoWhenVisibilityChangeListener();
    this.deleteDoWhenMessageReceivedFromShoutingRoom();
    if (this.waitPromiseTimeoutId) {
      window.clearTimeout(this.waitPromiseTimeoutId);
    }
    window.removeEventListener('click', this.handleClickEvent);
  };
  handleClickEvent = (evt) => {
    if (evt.detail === 3) {
      this.doWhenTrippleClick();
    }
  };
  createDagMessageData = () => {
    return {
      SubType: VIDABOO_CONSTANTS.DAG_SUBTYPES.ENDPOINT_INDICATION,
      //'clientUserId': contScope.user.userId,
      // senderProfileName: this.currentUser.userId,
      senderUserId: this.myUserId,
      message: VIDABOO_CONSTANTS.ENDPOINT_INDICATION_STATES.ARRIVED, // default msessage
      senderCreationTime: this.pageViewStartTime,
      sessionStartTime: this.pageViewStartTime,
      isMobileDevice: this.isMobileDevice, //todomcss : ok
      currentPage: this.props.getPageLocation(),
      // mentorId: this.props.mentor.mentorId,
      connectionContextOwnerType: VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.MENTOR,
      connectionContextOwnerId: this.props.mentor.mentorId,
    };
  };
  waitForMeAvailablePromise = () => {
    this.waitPromiseTimeoutId = setTimeout(() => {
      // waiting till I publish that I'm available in my shouting room (handled by authentication service).
      // otherwise, could cause mentor to fetch my availability before it's been updated to "available" hence causing false leave of page.
      const multiDagSentArrivedIndication =
        this.props.widgetDto.widgetAppCtrlDto.isAqIndicationsEnabled &&
        !this.props.widgetDto.mentorsControlMapDto[this.props.mentor.mentorId]
          .disableAqIndications &&
        this.props.widgetContext.arrivedIndicationReceivedMentorIds.includes(
          this.props.mentor.mentorId, //for some reason (like opening widget using btns) multi dag doesn't send the "arrived" indication
        );
      if (!UtilsService.getIsInWidget() || !multiDagSentArrivedIndication) {
        //in widget the multi dag component will send the indication
        ListeningRoomService.publishToListeningRoom(
          this.createDagMessageData(),
          this.myUserId,
          this.peerUserId,
          VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER,
        );
        this.props.widgetContext.setArrivedIndicationReceivedMentorId(
          this.props.mentor.mentorId,
        ); // update the array so that multiDagComponent knows that the indication (of "arrived") for this specific mentor is already being send
      }
      if (VisibilityHandlerService.getIsVisibilityHidden()) {
        var firstMsgObj = this.createDagMessageData();
        firstMsgObj.message =
          VIDABOO_CONSTANTS.ENDPOINT_INDICATION_STATES.HIDDEN;
        ListeningRoomService.publishToListeningRoom(
          firstMsgObj,
          this.myUserId,
          this.peerUserId,
          VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER,
        );
      }
    }, 2000);
  };
  registerListeners = () => {
    this.deleteDoWhenMessageReceivedFromShoutingRoom =
      ShoutingRoomService.doWhenMessageReceivedFromShoutingRoom(
        this.peerUserId,
        (messageFromShoutingRoom) => {
          if (
            messageFromShoutingRoom.senderUserId === this.peerUserId &&
            messageFromShoutingRoom.messageType ===
              VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER &&
            messageFromShoutingRoom.content.SubType ===
              VIDABOO_CONSTANTS.DAG_SUBTYPES.STATUS_REQUEST
          ) {
            // in case mentor re-joined or changed his status, we send that we're here.
            // console.debug('Responding to statusRequest');
            // ListeningRoomService.publishToListeningRoom(contScope.createDagMessageData(), contScope.myUserId, contScope.peerUserId, VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER);
            var msgObj = this.createDagMessageData();
            if (VisibilityHandlerService.getIsVisibilityHidden()) {
              // sending second message that we're hidden
              msgObj.message =
                VIDABOO_CONSTANTS.ENDPOINT_INDICATION_STATES.HIDDEN;
            }
            ListeningRoomService.publishToListeningRoom(
              msgObj,
              this.myUserId,
              this.peerUserId,
              VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER,
            );
          }
        },
        null,
        true,
      );

    this.deleteDoWhenVisibilityChangeListener =
      VisibilityHandlerService.doWhenVisibilityChange((visibilityIsHidden) => {
        var msgObj;
        // console.debug('visibilitychangeEvent: ' + visibilityIsHidden);
        if (visibilityIsHidden === true) {
          msgObj = this.createDagMessageData();
          msgObj.message = VIDABOO_CONSTANTS.ENDPOINT_INDICATION_STATES.HIDDEN;
          ListeningRoomService.publishToListeningRoom(
            msgObj,
            this.myUserId,
            this.peerUserId,
            VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER,
          );
        } else {
          msgObj = this.createDagMessageData();
          msgObj.message = VIDABOO_CONSTANTS.ENDPOINT_INDICATION_STATES.VISIBLE;
          ListeningRoomService.publishToListeningRoom(
            msgObj,
            this.myUserId,
            this.peerUserId,
            VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER,
          );
        }
      });
  };

  doWhenTrippleClick = () => {
    var firstMsgObj = this.createDagMessageData();
    firstMsgObj.message =
      VIDABOO_CONSTANTS.ENDPOINT_INDICATION_STATES.ATTENTION;
    ListeningRoomService.publishToListeningRoom(
      firstMsgObj,
      this.myUserId,
      this.peerUserId,
      VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.ENGAGER,
    );
  };
  registerTrippleClickAction = () => {
    PostMessageService.doWhenTrippleClick(this.doWhenTrippleClick);
  };
  render() {
    return null;
  }
}

DagComponent.propTypes = propTypes;
export default withWidgetContext(DagComponent);
